export default "__VITE_ASSET__DP8acBCJ__"